import { render, staticRenderFns } from "./TermsAndConditionsView.vue?vue&type=template&id=64a41b96&"
import script from "./TermsAndConditionsView.vue?vue&type=script&lang=js&"
export * from "./TermsAndConditionsView.vue?vue&type=script&lang=js&"
import style0 from "./TermsAndConditionsView.vue?vue&type=style&index=0&id=64a41b96&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports